export default __webpack_public_path__ + "static/media/skovstykket-townhouse-4-rooms-01.6861b17e.jpg";